import { createAsyncThunk } from "@reduxjs/toolkit"
import axiosInstance, { axiosCacheInstance } from "../../../axiosSetup"
import { AxiosError } from 'axios';
import { getDateTimeFormat } from "../../../helpers/dateFormat";
import moment from "moment";

// export const submitBlRequest = createAsyncThunk(
//     'payorDashboard/submitBlRequest',
//     async (finalPayload: any) => {
//         try {
//             console.log("Submitting payload:", finalPayload);
//             const response = await axiosInstance.post(
//                 `/api/edo-rest-v2/v2/blRequest/submit`, finalPayload
//             );
//             return response.data;
//         } catch (e) {
//             const error = e as AxiosError;
//             return {};
//         }
//     }
// );


export const submitBlRequest = createAsyncThunk(
  'payorDashboard/submitBlRequest',
  async (finalPayload: any, { rejectWithValue }) => {
    try {
      console.log("Submitting payload:", finalPayload);
      const response = await axiosInstance.post(
        `/api/edo-rest-v2/v2/blRequest/submit`,
        finalPayload
      );

     
      if (response.data?.status === 'FAILED') {
        return rejectWithValue(response.data);
      }

      return response.data;
    } catch (error: any) {
      // Pass error payload to the rejected action
      return rejectWithValue(
        error?.response?.data || { responseMsg: 'Something went wrong' }
      );
    }
  }
);



// export const approvereject = createAsyncThunk(
//     'payorDashboard/submitapprovereject',
//     async (payload: any) => {
//         try {
//             const response = await axiosInstance.post(
//                 `/api/edo-rest-v2/v2/blRequest/approveReject`, payload
//             );
//             return response.data;
//         } catch (e) {
//             const error = e as AxiosError;
//             return {};
//         }
//     }
// );


export const approvereject = createAsyncThunk(
  'payorDashboard/approvereject',
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/edo-rest-v2/v2/blRequest/approveReject',
        payload
      );

      
      if (response.data?.status === 'FAILED') {
        return rejectWithValue(response.data);
      }

      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data || { responseMsg: 'Something went wrong' }
      );
    }
  }
);




export const mergeDocList = (
    payloadDocList: any[],
    dropdownDocList: any[],
    attachmentData: any[]
): { updatedDocList: any[] } => {

    if (!Array.isArray(payloadDocList)) payloadDocList = [];
    if (!Array.isArray(dropdownDocList) || dropdownDocList.length === 0) {
        return { updatedDocList: payloadDocList };
    }
    if (!Array.isArray(attachmentData)) attachmentData = [];

    const dropdownDocId = dropdownDocList.map((i: any) => i.id);

    const dropdownDocs = attachmentData
        .filter((i: any) => dropdownDocId.includes(i.docId))
        .map((e: any) => ({
            rowNumber: crypto.randomUUID(),
            id: e?.docId,
            name: dropdownDocList.find((i: any) => i?.id === e?.docId)?.name,
            m: true,
            isDropDownDoc: true
        }));

    return {
        updatedDocList: [...payloadDocList, ...dropdownDocs]

    };


};

export const docConfigAndAttData = (
    payloadDocList: any[]
): any => {

    if (!Array.isArray(payloadDocList) || payloadDocList.length === 0) {
        return {
            dropdownDocList: [],
            docList: [],
            attDataList: []
        };
    }
    const updatedDocList = payloadDocList?.filter((i: any) => (i.isMandatory != "H" && i.isMandatory != "E"))?.map?.((i: any) => ({
        rowNumber: crypto.randomUUID(),
        id: i?.docId,
        name: i.docName,
        m: i.isMandatory == 'Y',
        // m: i.isMandatory === 'H' || i.isMandatory === 'Y',
    }))


    const dropdownOptions = payloadDocList?.filter((i: any) => (i.isMandatory == "H"))?.map?.((i: any) => ({
        id: i?.docId,
        name: i.docName,
        m: true,
        isDropDownDoc: true
    }))

    const dropdownDocList = dropdownOptions ?? []


    const docList = updatedDocList ?? []
    const attDataList = (updatedDocList ?? [])?.map((x: any) => ({
        rowNumber: x.rowNumber,
        attachmentId: null,
        docId: x.id,
        fileName: "",
        verify: false,
        actionBy: "",
        actionOn: "",
        m: x.m,
        ...(x.hasOwnProperty('isDropDownDoc') ? { isDropDownDoc: x.isDropDownDoc } : {})
        // isDropDownDoc: x?.isDropDownDoc
    }))

    return { dropdownDocList, docList, attDataList }
};

export const linerDocConfigAndAttData = (
    payloadDocList: any[]
): any => {

    if (!Array.isArray(payloadDocList) || payloadDocList.length === 0) {
        return {
            dropdownDocList: [],
            docList: [],
            attDataList: []
        };
    }
    let updatedDocList = payloadDocList?.filter((i: any) => (i.isMandatory != "H" && i.isMandatory != "E"))?.map?.((i: any) => ({
        rowNumber: crypto.randomUUID(),
        id: i?.docId,
        name: i.docName,
        m: i.isMandatory == 'Y',
        // m: i.isMandatory === 'H' || i.isMandatory === 'Y',
    }))

    const dropdownOptions = payloadDocList?.filter((i: any) => (i.isMandatory == "H"))?.map?.((i: any) => ({
        id: i?.docId,
        name: i.docName,
        m: true,
        isDropDownDoc: true
    }))

    const dropdownDocList = dropdownOptions ?? []

    if (updatedDocList.length === 0 && dropdownOptions && dropdownOptions.length > 0) {

        const rowNumber = crypto.randomUUID()
        const newDoc = { rowNumber: rowNumber, ...dropdownOptions[0] };

        updatedDocList = [...(updatedDocList ?? []), newDoc]

    }

    const docList = updatedDocList ?? []
    const attDataList = (updatedDocList ?? [])?.map((x: any) => ({
        rowNumber: x.rowNumber,
        attachmentId: null,
        docId: x.id,
        fileName: "",
        verify: false,
        actionBy: "",
        actionOn: "",
        m: x.m,
        ...(x.hasOwnProperty('isDropDownDoc') ? { isDropDownDoc: x.isDropDownDoc } : {})
        // isDropDownDoc: x?.isDropDownDoc
    }))
    return { dropdownDocList, docList, attDataList }
};

export const getNewBlRequestDetails = createAsyncThunk(
    'payorDashboard/getNewBlRequestDetails',
    async (payload: any) => {
        try {

            const docConfigResponse = await axiosCacheInstance.get(
                `/api/edo-rest-v2/v2/common/attachments?countryCode=${payload.country}&linerId=${payload.linerId}&instructionType=817`
                , {
                    cache: {
                        ttl: 10 * 60 * 1000
                    }
                })


            // const docConfigResponse = [
            //     {
            //         "attachmentConfigId": 600,
            //         "docId": 100,
            //         "isMandatory": "Y",
            //         "docName": "Payment Receipt"
            //     },
            //     {
            //         "attachmentConfigId": 601,
            //         "docId": 101,
            //         "isMandatory": "H",
            //         "docName": "Others"
            //     }
            // ]


            const { dropdownDocList, docList, attDataList } = docConfigAndAttData(docConfigResponse?.data)

            const response = await axiosInstance.get(
                `api/edo-rest-v2/v2/blRequest/getBlRequestById?blRequestId=${payload.newblid}`
            );

            // const responseData = {
            //     newBlRequestId: null,
            //     bookingNumber: 'BKG123456',
            //     blNumber: 'BL987654',
            //     registeredEmailAddress: '',
            //     shipmentType: '',
            //     blType: '2',
            //     blLocation: '1',
            //     agentName: 'John Doe',
            //     agentNumber: '1234567890',
            //     // validTill: '2025-12-15T21:00:00Z',
            //     validTill: '',
            //     lockerPin: '',
            //     email: 'agent@example.com',
            //     linerRemarks: '',
            //     releaseToCustomer: 'Y',
            //     status: 'Submitted',
            //     dndInstructionAtt: [
            //         {
            //             dndInstructionAttId: 123,
            //             docId: 100,
            //             filePath: "",
            //             fileName: "Dummy1.pdf"
            //         },
            //         {
            //             dndInstructionAttId: 1234,
            //             docId: 101,
            //             filePath: "",
            //             fileName: "Dummy2.pdf"
            //         }
            //     ]

            // };

            const { updatedDocList } = mergeDocList(docList, dropdownDocList, response.data?.documents)
            const visitedAttId: any[] = [];
            const visitedLinerAttId: any[] = [];
            // Determine which doc list to use based on extFlag
            const targetDocList = updatedDocList;
            console.log(targetDocList, "targetDocList")

            // Always populate attList based on targetDocList, even if dndInstructionAtt is null
            const attList = targetDocList?.map((x: any) => {

                const value = response?.data?.documents?.find(
                    (f: any) => f?.docId === x?.id && !visitedAttId.includes(f?.attachmentId)
                );

                if (value?.attachmentId) {
                    visitedAttId.push(value.attachmentId);
                }

                return {
                    rowNumber: x?.rowNumber,
                    attachmentId: value?.attachmentId || null,
                    docId: x?.id,
                    filePath: value?.filePath || null,
                    fileName: value?.fileName || null,
                    m: x?.m,
                    isDropDownDoc: x?.isDropDownDoc
                };
            }) ?? [];


            console.log(attList, "attList123")
            const linerDocuments = response?.data?.linerDocuments ?? [];

            const normalizedLinerDocuments = linerDocuments.map((doc: any) => ({
                fileName: doc.fileName ?? "",
                filePath: doc.filePath ?? "",
                docId: doc.docId ?? 0,
                attachmentId: doc.attachmentId ?? null,
                userType: doc.userType ?? "",
            }));



            return {
                // newBlRequestId: responseData?.newBlRequestId,
                bookingNumber: response?.data?.booking_no ?? "",
                blNumber: response?.data?.bl_no ?? "",
                registeredEmailAddress: response?.data?.payor_registered_email ?? "",
                shipmentType: response?.data?.shipment_type ?? "",
                blType: response?.data?.bl_type ?? "",
                blLocation: response?.data?.bl_location ?? "",
                agentName: response?.data?.agent_name ?? "",
                agentNumber: response?.data?.agent_number ?? "",
                email: response?.data?.payor_email ?? "",
                status: response?.data?.status ?? "",
                linerRemarks: response?.data?.liner_remark ?? "",
                releaseToCustomer: response?.data?.release_to_customer ?? "N",
                validTill: response?.data?.valid_till ??"",
                lockerPin: response?.data?.locker_pin ?? "",
                lockerUnit: response?.data?.lockerUnit ?? "",
                attList: attList,
                updatedDocListData: targetDocList,
                dropdownDocList: dropdownDocList,
                linerDocuments: normalizedLinerDocuments,

            };

        } catch (e) {
            console.error(' New Bl request data error', e);

            const error = e as AxiosError;
            return {};
        }
    }
);

// export const getShipmentTypeList = createAsyncThunk(
//     "payorDashboard/getShipmentTypeList",
//     async ({ dataCountry, linerId }: any) => {
//         try {
//             const response = await axiosCacheInstance.get(
//                 `/api/edo-rest-v2/v2/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=EXC_SHIPMENT_TYPE&linerId=${linerId}&countryCode=${dataCountry}`,
//                 {
//                     cache: {
//                         ttl: 10 * 60 * 1000
//                     }
//                 }
//             );

//             const shipmentTypeOption = response.data.map((item: any) => ({
//                 value: item.codeId,
//                 label: item.codeDesc,
//             }));

//             return shipmentTypeOption
//         }
//         catch (error) {
//             return [];
//         }
//     }
// );


// export const getBlCopyTypeList = createAsyncThunk(
//     "payorDashboard/getBlCopyTypeList",
//     async ({ dataCountry, linerId }: any) => {
//         try {
//             const response = await axiosCacheInstance.get(
//                 `/api/edo-rest-v2/v2/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=EXC_BL_COPY_TYPE&linerId=${linerId}&countryCode=${dataCountry}`,
//                 {
//                     cache: {
//                         ttl: 10 * 60 * 1000
//                     }
//                 }
//             );

//             const blCopyTypeOption = response.data.map((item: any) => ({
//                 value: item.codeId,
//                 label: item.codeDesc,
//             }));

//             return blCopyTypeOption
//         }
//         catch (error) {
//             return [];
//         }
//     }
// );

export const getBlTypeList = createAsyncThunk(
    "payorDashboard/getBlTypeList",
    async ({ dataCountry, linerId }: any) => {
        try {
            const response = await axiosCacheInstance.get(
                `/api/edo-rest-v2/v2/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=EXC_BL_TYPE&linerId=${linerId}&countryCode=${dataCountry}`,
                {
                    cache: {
                        ttl: 10 * 60 * 1000
                    }
                }
            );

            const blTypeOption = response.data?.map((item: any) => ({
                value: item.codeId,
                label: item.codeDesc,
            }));

            return blTypeOption

        }
        catch (error) {
            return [];
        }
    }
);

export const getBlLocationList = createAsyncThunk(
    "payorDashboard/getBlLocationList",
    async ({ dataCountry, linerId }: any) => {
        try {
            const response = await axiosCacheInstance.get(
                `/api/edo-rest-v2/v2/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=EXC_BL_LOCATION&linerId=${linerId}&countryCode=${dataCountry}`,
                {
                    cache: {
                        ttl: 10 * 60 * 1000
                    }
                }
            );

            const blLocationTypeOption = response.data?.map((item: any) => ({
                value: item.codeId,
                label: item.codeDesc,
            }));

            return blLocationTypeOption

        }
        catch (error) {
            return [];
        }
    }
);

export const getLatestBlRequestIdByBlNo = createAsyncThunk(
    "payorDashboard/getLatestBlRequestIdByBlNo",
    async (blNo: string, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(
                `/api/edo-rest-v2/v2/blRequest/getLatestBlRequestIdByBlNo`,
                {
                    params: { blNo }
                }
            );

            return response.data;
        } catch (error: any) {
            return rejectWithValue(
                error?.response?.data || { responseMsg: 'Something went wrong' }
            );
        }
    }
);


export const getNewBlRequestAttConf = createAsyncThunk(
    'payorDashboard/getNewBlRequestAttConf',
    async (payload: { country: string; liner: any; }, { dispatch }) => {
        // async () => {

        try {
            const response = await axiosInstance.get(
                `/api/edo-rest-v2/v2/common/attachments?countryCode=${payload.country}&linerId=${payload.liner}&instructionType=817`
            )
            console.log(response.data, "oiuss");
            return response.data;

            // const response = [
            //     {
            //         "attachmentConfigId": 600,
            //         "docId": 100,
            //         "isMandatory": "Y",
            //         "docName": "Payment Receipt"
            //     },
            //     {
            //         "attachmentConfigId": 601,
            //         "docId": 101,
            //         "isMandatory": "H",
            //         "docName": "Others"
            //     }
            // ]
            // return response
        }
        catch (e) {
            return [];
        }
    }
)


